import React from "react";

import styles from "./styles.module.css";

export function Sparkle() {
    return (
        <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M14.25 6.25L15.1875 4.1875L17.25 3.25L15.1875 2.3125L14.25 0.25L13.3125 2.3125L11.25 3.25L13.3125 4.1875L14.25 6.25ZM8.625 6.625L6.75 2.5L4.875 6.625L0.75 8.5L4.875 10.375L6.75 14.5L8.625 10.375L12.75 8.5L8.625 6.625ZM14.25 10.75L13.3125 12.8125L11.25 13.75L13.3125 14.6875L14.25 16.75L15.1875 14.6875L17.25 13.75L15.1875 12.8125L14.25 10.75Z"
                fill="black"
            />
        </svg>
    );
}

export function PlayIcon() {
    return (
        <svg
            className={styles.icon}
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40ZM16 27L28 20L16 13L16 27Z"
                data-component="inner-circle"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M28 20L16 27L16 13L28 20Z"
                data-component="icon"
            />
            <circle cx="20" cy="20" r="19" stroke="white" strokeWidth="2" />
        </svg>
    );
}

export function Lock() {
    return (
        <svg
            width="12"
            height="15"
            viewBox="0 0 12 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M9.99935 5.50016H9.33268V4.16683C9.33268 2.32683 7.83935 0.833496 5.99935 0.833496C4.15935 0.833496 2.66602 2.32683 2.66602 4.16683V5.50016H1.99935C1.26602 5.50016 0.666016 6.10016 0.666016 6.8335L0.666016 13.5002C0.666016 14.2335 1.26602 14.8335 1.99935 14.8335H9.99935C10.7327 14.8335 11.3327 14.2335 11.3327 13.5002V6.8335C11.3327 6.10016 10.7327 5.50016 9.99935 5.50016ZM5.99935 11.5002C5.26602 11.5002 4.66602 10.9002 4.66602 10.1668C4.66602 9.4335 5.26602 8.8335 5.99935 8.8335C6.73268 8.8335 7.33268 9.4335 7.33268 10.1668C7.33268 10.9002 6.73268 11.5002 5.99935 11.5002ZM8.06602 5.50016H3.93268V4.16683C3.93268 3.02683 4.85935 2.10016 5.99935 2.10016C7.13935 2.10016 8.06602 3.02683 8.06602 4.16683V5.50016Z"
                fill="currentColor"
            />
        </svg>
    );
}

function filterKeyEnter(handler: (event: React.KeyboardEvent) => void) {
    return (e: React.KeyboardEvent) => {
        if (e.key === "Enter") {
            handler(e);
        }
    };
}

export function accessibleOnClick(handler: () => void) {
    return {
        role: "button",
        onKeyDown: filterKeyEnter(handler),
        tabIndex: 0,
        onClick: handler,
    };
}
